export default "__VITE_ASSET__BOOMaMCd__";